import React, { useState, useEffect } from 'react'
import $ from 'jquery'
import { getData, putData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import Header from '../../../components/generals/header'
import Loading from '../../../components/generals/loading'
import styles from '../../../css/generals/Checkbox.module.css'
import stylesPreferences from '../../../css/preferences/Preferences.module.css'
import stylesIndex from '../../../css/Index.module.css'
import { compareObj } from '../../../components/generals/toolsFunctions'
import store from '../../../reducer/store'
import { popupSimple } from '../../../components/generals/popups'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function Configs () {
  // const data = useSelector((state) => state.preferences.configs);
  const [settingsToCompare, setsettingsToCompare] = useState({})
  const [configs, setConfigs] = useState({})
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('connectionPreferences')
  const navigate = useNavigate()

  useEffect(() => {
    const getPreferences = async () => {
      const { data } = await getData('preferences', 1, navigate)
      // console.log(data)
      if (data) {
        setConfigs(data)
        setsettingsToCompare(data)
        viewCheckbox(data.use_other)
      }
    }

    getPreferences()
  }, [])

  function viewCheckbox (others) {
    if (others === true) {
      $('#others_use').prop('checked', true)
    } else {
      $('#others_use').prop('checked', false)
    }
  }

  const handleInputChange = (e) => {
    if (e.target.name === 'use_other') {
      $('#google_use').prop('checked', false)
      setConfigs({
        ...configs,
        [e.target.name]: $('#others_use').is(':checked')
      })
    } else if (e.target.name === 'use_google' || e.target.name === 'applications' || e.target.name === 'stats') {
      const id = e.target.name === 'use_google' ? 'google_use' : e.target.name
      setConfigs({
        ...configs,
        [e.target.name]: $(`#${id}`).is(':checked')
      })
    } else {
      setConfigs({
        ...configs,
        [e.target.name]: e.target.type === 'number' ? parseInt(e.target.value) : e.target.value === '' ? null : e.target.value
      })
    }
  }

  const sendConfigs = async () => {
    const date = new Date().toISOString()

    const comparation = compareObj(configs, settingsToCompare)

    if (configs.use_google && (configs.url_google === null || configs.url_google === '')) {
      popupSimple('info', t('message1'))
    } else if (configs.use_google && (configs.key_google === null || configs.key_google === '')) {
      popupSimple('info', t('message2'))
    } else if (comparation) {
      popupSimple('info', t('message3'))
    } else {
      setConfigs({
        ...configs,
        date
      })

      const { data } = await putData('preferences', configs, navigate)
      if (data.result === true) {
        popupSimple('success', t('message4'))
      } else {
        popupSimple('error', t('message5'))
      }
    }
    setsettingsToCompare(configs)
  }

  if (Object.keys(configs).length === 0) {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Loading color="primary"/>
        </div>
      </div>)
  } else {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('title')} margin="0" />
          {role?.preferencesSettingsPage.times &&
          <>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label1')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_connection} name="time_connection" onChange={handleInputChange} type="number" min={5} max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label2')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_persistence} name="time_persistence" type="number" onChange={handleInputChange} min={5}
            max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
           {/*  <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label3')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small2')})</small>
                <input value={configs.time_off_line_disconnection} name="time_off_line_disconnection" type="number" onChange={handleInputChange} min={1}
             className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div> */}
          </>}
          {role?.preferencesSettingsPage.locations &&
          <>
           {/*  <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label4')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.use_other} checked={configs.use_other} id="others_use" name="use_other" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div> */}
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label10')}</label>
                <small className={`"text-muted" ${stylesPreferences.minutesPref}`}>({t('small1')})</small>
                <input value={configs.time_location} onChange={handleInputChange} name="time_location" type="number" min={1} max={525600} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
              </div>
            </div>
          </>}
          {role?.preferencesSettingsPage.reports &&
          <>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label11')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.applications} checked={configs.applications} id="applications" name="applications" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
            <div className={styles.componentBox}>
              <div className={`${styles.containerDiv} ${stylesPreferences.align}`}>
                <label className={`${styles.sliderLabel} ${stylesPreferences.labelPref}`}>{t('label12')}</label>
                <label className={`${styles.switch} ${stylesPreferences.switchPref}`}>
                  <input value={configs.stats} checked={configs.stats} id="stats" name="stats" type="checkbox" onChange={handleInputChange} className={`${styles.focus} ${stylesPreferences.inputsPref}`}/>
                  <span className={`${styles.slider} ${styles.round} ${styles.inputsLabels}`}/>
                </label>
              </div>
            </div>
          </>}
          <div className={`end-footer-body ${stylesPreferences.btnEnd}`}>
            <Button onClick={sendConfigs} variant="dark">
            <i className="fas fa-save" style={{ marginRight: '0.5rem' }}></i>
            {t('button1')}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
